import React, {Component} from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import ArchiveCompanyValueMutation from "@irati/companyvalues/apollo/mutation/Archive"
import {CompanyValue} from "@irati/companyvalues/types"
import authentication from "@irati/auth"
import {companyValuesTracking} from "@irati-tracking/admin"

import {AreYouSurePopUp} from "../../AreYouSurePopUp/index"

interface Props extends InjectIntl {
  closeArchiveModal(): void
  companyValue: CompanyValue
}

class CompanyValueArchive extends Component<Props> {
  submit = (onSubmit: any) => {
    companyValuesTracking.archiveCompanyValue()
    onSubmit()
  }

  render() {
    const {closeArchiveModal, companyValue, formatMessage} = this.props
    const tenantId = authentication.userTenant().uuid
    const load = false

    return (
      <ArchiveCompanyValueMutation companyValue={companyValue} onCompleted={closeArchiveModal} tenantId={tenantId}>
        {(onSubmit: any) => (
          <AreYouSurePopUp
            buttonText={formatMessage({id: "admin.companyValues.archive.button"})}
            load={load}
            onCancel={closeArchiveModal}
            onSubmit={() => this.submit(onSubmit)}
            open
            text={formatMessage({id: "admin.companyValues.archive.body"})}
          />
        )}
      </ArchiveCompanyValueMutation>
    )
  }
}

export default injectIntl(CompanyValueArchive)
